import React from "react";

export default function InlineConfirmation(props) {

    return (
        <>
            <div css="display: flex;
            justify-content: flex-end;
            user-select:none;
            align-items: center;">
            <div css={`
                color:red;
                font-weight:bolder;
            `}>{props.message}</div>
                <div css="color:gray;margin-left: 20px; cursor:pointer" onClick={(e) => { 
                  e.stopPropagation()
                  e.preventDefault(); 
                  props.onCancel(); }}>
                    {props.cancelBtnText}
                </div>
                <div css="
            font-weight:bolder;
            color:red;
            margin-left: 20px; cursor:pointer;" onClick={(e) => { 
              e.stopPropagation()
              e.preventDefault();
              props.onConfirm(); }}>
                    {props.confirmationBtnText}
                </div>
            </div>
        </>
    )

}